import { gql } from '@apollo/client';

export interface Annotation {
  pdfId: number;
  annotations: string;
  createdAt: string;
  updatedAt: string;
}

export const SAVE_ANNOTATION = gql`
  mutation SaveAnnotation(
    $pdfDocumentAnnotationId: Int
    $uploadFileId: Int!
    $authorId: Int!
    $text: String!
    $annotationPageNumber: Int
    $xLocation: Int
    $yLocation: Int
  ) {
    saveAnnotation(
      pdfDocumentAnnotationId: $pdfDocumentAnnotationId
      uploadFileId: $uploadFileId
      authorId: $authorId
      text: $text
      annotationPageNumber: $annotationPageNumber
      xLocation: $xLocation
      yLocation: $yLocation
    ) {
      message
      success
    }
  }
`;

export const DELETE_ANNOTATION = gql`
  mutation DeleteAnnotation($annotationId: Int!) {
    deletePdfDocumentAnnotation(annotationId: $annotationId) {
      message
      success
    }
  }
`;

export const GET_ANNOTATIONS = gql`
  query GetPdfDocumentAnnotations($uploadFileId: Int!) {
    getPdfDocumentAnnotations(uploadFileId: $uploadFileId) {
      edges {
        node {
          dbId
          uploadFileId
          authorId
          text
          annotationPageNumber
          xLocation
          yLocation
          datetimeCreated
          datetimeModified
        }
      }
    }
  }
`;

export const GET_COMPANY_ANNOTATIONS = gql`
  query GetAllPdfDocumentAnnotations($companyId: Int!) {
    getAllPdfDocumentAnnotations(companyId: $companyId) {
      edges {
        node {
          dbId
          uploadFileId
          text
          annotationPageNumber
          xLocation
          yLocation
          datetimeCreated
          datetimeModified
        }
      }
    }
  }
`;

export const GET_PDF_CATEGORIES = gql`
  query GetPdfCategories {
    pdfDocumentAnnotationsMenuCategories
  }
`;
